import React from "react";
import { ArrowRight } from "lucide-react";

import SpokePage from "./SpokePage";

import "../preview/Design13.css";
import "../preview/Design13Audience.css";
import "./Editorial.css";

/* Dedicated page: /employers/brief — email-first contact CTA (no form). */
export default function BriefPage() {
  const email = "info@adelgroups.com";
  const subject = "Employer enquiry — Request workers";
  const body = [
    "Hi Adel Group,",
    "",
    "We'd like help staffing the following:",
    "",
    "• Company:",
    "• Country / location:",
    "• Role / sector:",
    "• Headcount & target start date:",
    "• Notes:",
    "",
    "Thanks",
  ].join("\n");
  const mailto = `mailto:${email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;

  return (
    <SpokePage
      audience="employer"
      eyebrow="Talk to us"
      title={<>Tell us who you need.</>}
      intro="Skip the form — send us one email and our team gets to work: realistic salary bands, lead times, and a starter shortlist back to you within 48 hours."
    >
      <section className="ed-band ed-band--cream ed-pad">
        <div className="ed-container" style={{ textAlign: "center" }}>
          <a href={mailto} className="d13-btn d13-btn--primary">
            Contact us <ArrowRight size={16} strokeWidth={2.2} />
          </a>
          <p style={{ marginTop: "1.1rem", opacity: 0.72, fontSize: "0.95rem" }}>
            Or email us directly at{" "}
            <a href={`mailto:${email}`} style={{ textDecoration: "underline" }}>
              {email}
            </a>
          </p>
        </div>
      </section>
    </SpokePage>
  );
}
